<template>
    <v-data-table
      :headers="headers"
      :items="addOnListSpeciality"
      height="auto"
      class="elevation-1"
      no-data-text="Sin resultados disponibles"
      fixed-header dense
      :footer-props="{
          'items-per-page-text': 'Elementos por página',
          'items-per-page-all-text': 'Todo',
          'items-per-page-options': [10],
        }"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip v-if="isDelete" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="deleteAppointment(addOnListSpeciality.indexOf(item))"
              v-bind="attrs"
              v-on="on"
            >
              mdi mdi-delete
            </v-icon>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.guide`]="{ index }">
        <div>
          {{ index + 1 }}
        </div>
      </template>
      <template v-slot:[`item.selectTreatments`]="{ value }">
        <div v-for="(item, index) in value" :key="index">
          {{ item.text }}
        </div>
      </template>
    </v-data-table>
  </template>
  
  <script>
  export default {
    props: {
      addOnListSpeciality: {
        type: Array,
      },
    },
    data() {
      return {
        isDelete: true,
        headers: [
          { text: "#", value: "guide", align: "center" },
          { text: "Especialidad", value: "speciality.name", align: "center" },
          { text: "Modalidad", value: "modality.name", align: "center" },
          { text: "Perfil de estudio", value: "studyProfile.name", align: "center" },
          { text: "Acciones", value: "actions", sortable: false, width: "10%", align: "center" },
        ],
      };
    },
    methods: {
      deleteAppointment(index) {
      const newList = [...this.addOnListSpeciality];
      newList.splice(index, 1);
      this.$emit('update-list', newList);
    },
    }
  };
  </script>
  